// const dev = 'http://120.26.109.24:11200/' // 测试
// const prod = 'http://120.26.109.24:11200/' // 测试
const dev = 'https://api.ciif-expo.com/' // 正式
const prod = 'https://api.ciif-expo.com/' // 正式

/**
IP 地址 120.26.109.24 root / ip@@@2024
部署目录：
官网：/mnt/html/gbh-website/
登录账号：develop/Asdf1234?  wangsh/s198949

接口地址：http://120.26.109.24:11200/swagger-ui.html#!/

访问路径
管理平台：http://120.26.109.24:11220/
官网：http://120.26.109.24:11221/
 */

// 生产网址 https://www.ciif-expo.com/
const base = process.env.NODE_ENV === "production" ? prod : dev

export default base;


// WEBPACK FOOTER //
// ./src/api/base.js